import { WalletExtensionRdns as u } from "../constants/web3.js";
import { injected as s } from "@wagmi/connectors";
import { createConnector as w, ProviderNotFoundError as i } from "@wagmi/core";
import { withRetry as d, withTimeout as c } from "viem";
function a() {
  return w((e) => {
    const o = s()(e);
    return {
      ...o,
      id: u.Ronin,
      name: "Ronin",
      type: "ronin",
      async getProvider() {
        var r;
        if (typeof window > "u")
          return null;
        if ((r = window.ronin) != null && r.provider)
          return window.ronin.provider;
        let n;
        try {
          n = await d(
            () => c(
              () => {
                var t;
                if (!window)
                  return null;
                if (!((t = window.ronin) != null && t.provider))
                  throw new i();
                return window.ronin.provider;
              },
              {
                timeout: 100
              }
            ),
            {
              delay: 1e3
            }
          );
        } catch {
          return null;
        }
        return n;
      },
      async isAuthorized() {
        var n;
        try {
          if (await ((n = e.storage) == null ? void 0 : n.getItem(
            `${o.id}.disconnected`
          ))) return !1;
          if (!await this.getProvider())
            throw new i();
          return !!(await d(
            () => c(() => this.getAccounts(), {
              timeout: 1e3
            })
          )).length;
        } catch {
          return !1;
        }
      }
    };
  });
}
a.type = "ronin";
export {
  a as roninConnector
};
//# sourceMappingURL=roninConnector.js.map
